// HeroImage.js - Displays hero image for a specific shop
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "./style/HeroImage.css";

export default function HeroImage({ shopId }) {
    const [heroImage, setHeroImage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
const api = "https://mkbackend-production.up.railway.app"
    
    useEffect(() => {
        const fetchHero = async () => {
            try {
                setLoading(true);
                setError(null);
                
                const res = await axios.get(`${api}/hero/${shopId}`);
                
                console.log("Hero response:", res.data);
                
                if (res.data.success && res.data.hero) {
                    setHeroImage(res.data.hero);
                } else {
                    setError('No hero image found');
                }
            } catch (error) {
                console.error("Error fetching hero:", error);
                setError(error.response?.data?.message || 'Error fetching hero image');
            } finally {
                setLoading(false);
            }
        };

        if (shopId) {
            fetchHero();
        }
    }, [shopId]);

    if (loading) {
        return (
            <div className="hero-placeholder-loading">
                <div className="hero-spinner"></div>
            </div>
        );
    }

    if (error || !heroImage || !heroImage.heroImages) {
        return (
            <div className="hero-placeholder">
                <span>🏪</span>
                <p>No Hero Image</p>
            </div>
        );
    }

    return (
        <div className="hero-image-container">
            <img 
                src={heroImage.heroImages} 
                alt={heroImage.shopName || 'Shop Hero'} 
                className="hero-image"
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://via.placeholder.com/1200x400/667eea/ffffff?text=No+Image';
                }}
            />
        </div>
    );
}